export default "__VITE_ASSET__BiDE1wrl__"